import { FC } from "react";
import { useField } from 'formik';
import { IBaseField } from "./BaseField";
import { TextArea } from "src/Controls";

interface ITextFieldProps extends IBaseField {
	rows?: number;
	/** Подстраивать высоту инпута автоматически */
	isAutoHeight?: boolean;
};

/**
 * Текстовое поле
 */
const TextAreaField: FC<ITextFieldProps> = ( props ) => {
	
	const { name, ...otherProps } = props;
	const [ inputProps, meta ] = useField( name );

	return (
		<TextArea
			{...otherProps}
			{...inputProps}
			{...meta}
		/>
	);
};

export default TextAreaField;